import { Request, Response } from 'express';

import catchAsync from '@/shared/utils/catchAsync';
import * as tagService from '@/modules/master/constructionStatus/tags/tag.service';
import responseCodes from '@/shared/utils/responseCode/responseCode';
import { pick } from '@/shared/utils';

const { TagResponseCodes } = responseCodes;

export const create = catchAsync(async (req: Request, res: Response) => {
  const result = await tagService.create(req.body);
  res.success(result, TagResponseCodes.SUCCESS, 'Tags Created Successfully');
});

export const get = catchAsync(async (req: Request, res: Response) => {
  const result = await tagService.getById(req.params.id);
  res.success(result, TagResponseCodes.SUCCESS, 'Tags Fetched Successfully');
});

export const update = catchAsync(async (req: Request, res: Response) => {
  await tagService.update(req.params.id, req.body);
  res.success(true, TagResponseCodes.SUCCESS, 'Tags Updated Successfully');
});

export const remove = catchAsync(async (req: Request, res: Response) => {
  await tagService.remove(req.params.id);
  res.success(true, TagResponseCodes.SUCCESS, 'Tags Deleted Successfully');
});

export const list = catchAsync(async (req: Request, res: Response) => {
const filters = pick(req.query, [ 'search']);
  
    const options = pick(req.query, [
      'sortBy',
      'limit',
      'page',
      'populate',
      'fields',
    ]);
  
    const result = await tagService.queryTags(
      filters,
      options,
    );
  res.success(result, TagResponseCodes.SUCCESS, 'Tags Fetched Successfully');
});

